<!-- Updated -->
<script>
import * as m from '@app/paraglide/messages.js';
  /** @type {{event?: any}} */
  let { event = $bindable({}) } = $props();

    function markEvent() {
        event.forced = !event.forced;
    }
    </script>
<button
  id="forcedSubtitleBtn-{event.id}"
  type="button"
  class="btn btn-link text-decoration-none text-custom-medium {event.forced ? 'text-info fw-bold' : 'text-dark'}"
  onclick={() => markEvent()}
  aria-label={m.event_forced_aria_label()}
  title={m.event_forced_title()}>
    FS
</button>

<style lang="css">
    button {
        padding : 2px;
        margin: 0;
    }
</style>